import { Redirect } from 'expo-router';
import React from 'react';

/**
 * This route is no longer used - SystemForceUpdate is rendered directly
 * by InitializationProvider when force update or service maintenance is required.
 * Redirecting to root in case someone navigates here directly.
 */
export default function Page() {
  return <Redirect href="/" />;
}
